import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { marked } from "marked";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { SomeIcon } from "~/components/bloks/MediaCardBlok/SomeIcon";
import type { MediaCardStoryblok } from "~/generated/sb/blok-types";
import styles from "./MediaCardBlok.module.css";

export const MediaCardBlok = ({
	blok,
	sizes = "100vw",
	preview,
}: BlokProps<MediaCardStoryblok> & { sizes?: string }) => {
	const mediaBlok = blok?.media?.[0];

	const MainImage = () =>
		!mediaBlok ? null : (
			<div className={clsx(styles.image, "media-card--image")}>
				<StoryblokComponent sizes={sizes} blok={mediaBlok} preview={preview} />
			</div>
		);

	// text under image
	const AltText = () =>
		!blok?.imageText ? null : (
			<div
				dangerouslySetInnerHTML={{
					__html: marked.parse(blok?.imageText || ""),
				}}
			/>
		);

	const SocialTag = () =>
		!blok.socialTag ? null : (
			<div className={styles.socialIcon}>
				<SomeIcon socialIcon={blok.socialIcon} /> {blok?.socialTag}
			</div>
		);

	return (
		<BlokWrap editable={blok} className={clsx(styles.root, "media-card")}>
			<MainImage />
			<AltText />
			<SocialTag />
		</BlokWrap>
	);
};
